import { ChangeDetectorRef, Component, computed, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { skip } from 'rxjs';
import * as Highcharts from 'highcharts';
import { CommonService } from 'src/app/trip-replay/services/common.service';
import { MapControlService } from 'src/app/trip-replay/services/map-control.service';
import { EventLogicService } from 'src/app/trip-replay/services/event-logic.service';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { DateUtils } from 'src/app/utils/days-utils';
import { isValidCoordinate } from 'src/app/utils/constants';
import { DataService } from 'src/app/data.service';
@Component({
  selector: 'app-map-view-cab',
  templateUrl: './map-view-cab.component.html',
  styleUrls: ['./map-view-cab.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)', opacity: 0 }),
        animate('500ms ease-out', style({ transform: 'translateY(0)', opacity: 1 })),
      ]),
      transition(':leave', [
        animate('500ms ease-in', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class MapViewCabComponent implements OnInit {
  @Output() reStart = new EventEmitter<any>();
  @Input() driverData: any;
  Highcharts: typeof Highcharts = Highcharts;
  options: any = {
    series: [{ data: [0], dataLabels: {} }],
  };
  replayImgSrc: string;
  speedColor: any = '#F2FBFF';
  driverFixedDevice:boolean = false;
  disabledFixedDeviceToggle:boolean = false;
  noShowInterval: [];
  callEmployee: any;
  clickedMarker: google.maps.Marker | null = null;
  enableEmployeesDetails: boolean=false;
  currentDeviceOff: boolean;
  currentOverSpeedData: any;
  private activeInfoWindows: Map<string, google.maps.InfoWindow> = new Map();

  constructor(
    private commonService: CommonService,
    public mapControlService: MapControlService,
    private eventLogicService: EventLogicService,
    private envService: EnvironmentService,
    private cdr: ChangeDetectorRef,
    private dataService:DataService
  ) { }
  tripDetails = this.commonService.response.tripDetails;
  intervalTime: number;

  polyline: google.maps.Polyline;
  map: google.maps.Map | undefined;
  lat;
  lng;
  coordinates: google.maps.LatLng;

  plannedRouteToggle = false;
  planedRoutePath: google.maps.Polyline | undefined;

  vehicleCurrentLocationCords: any;
  formattedWaypoints: any[] = [];
  vehiclePreviousCoords: any;

  locationList: any[];
  vehicleStopageMarker: google.maps.Marker | undefined | null;
  geofenceMarker: google.maps.Circle | undefined | null;

  circleRadius: number;
  circleOpacity: number;

  mapOptions: google.maps.MapOptions;

  vehicleSpeed: number = 0;

  events: Object[];

  chart: any;

  empPickupDropForStops: Map<number, number> = new Map();
  geofenceHittedStops: Map<string, number> = new Map();

  // stopsToVisit: number[] = [];
  // minDistance: number = Number.MAX_SAFE_INTEGER;
  // minDistanceFromStops: number[] = [];

  vehicleStoppageIndexes: any[];

  indexForMilestone: number = 0;

  sosArrayRes: any;
  seatBeltArray:any
  overspeedingIntervals: any;
  vehicleArrivedIntervals:any;

  infoWindowOTAOTD: google.maps.InfoWindow;
  infoWindowSignin: google.maps.InfoWindow;

  isOverspeeding: boolean = false;
  startPlottingOverspeed: boolean = false;
  overspeedformattedWaypoints: google.maps.LatLng[] = [];
  increasing: boolean = true;
  strokeWidth: number = 4;
  maxStrokeWidth: number = 10;
  polylineAnimationList: any[] = [];

  networkLossIntervals: any[];
  startNetworkLoss: boolean = false;
  noInternetAnimation: any;
  busImageURL: string = `assets/icons/cab-on-map.svg`;

  deviceOffIntervals: any[];
  deviceNotConnectedMarker: google.maps.Marker;
  deviceOffStart: boolean = false;

  gpsLossIntervals: any[];
  gpsLossStart: boolean = false;
  gpsLossWaypoints: google.maps.LatLng[] = [];
  deviceOffWaypoints: google.maps.LatLng[] = [];
  networkLossWaypoints: google.maps.LatLng[] = [];

  assetPath: Object;
  showOverlay: boolean = false;
  showMapLoader: boolean = false;
  eventVisibility: Map<string, boolean> = this.mapControlService.eventVisibility;
  tripEnded:boolean = false;
  isAvoidTollsEnabled=computed(()=>this.dataService.isAvoidTollsEnabled())

  ngOnInit(): void {
    this.driverFixedDevice=this.commonService.driverFixedDevice;
    this.disabledFixedDeviceToggle=this.commonService.disabledFixedDeviceToggle;
    this.replayImgSrc = this.envService.getReplayImgSrc();
    // this.replayreplayImgSrc = this.envService.getReplayImgSrc();
    this.lat = this.tripDetails.plannedStartLocation.geocord?.split(',')[0];
    this.lng = this.tripDetails.plannedStartLocation.geocord?.split(',')[1];

    if(this.tripDetails.direction === 'OUT') {
      this.lat = this.tripDetails.plannedEndLocation.geocord?.split(',')[0];
      this.lng = this.tripDetails.plannedEndLocation.geocord?.split(',')[1];
    }
    this.coordinates = new google.maps.LatLng(this.lat, this.lng);
    this.mapOptions = {
      center: this.coordinates,
      zoom: 14,
      mapTypeControl: false,
    };


    this.commonService.locationListRes.subscribe((res) => {
      const length = res.length
      this.locationList = res.slice(this.commonService.outOfRangeLowerBound, res.length - this.commonService.outOfRangeUpperBound)
    });

    this.intervalTime = 100 / 6;

    this.mapControlService.callForFilterChange$.subscribe((res) => {
      if (res.length) {
        this.eventVisibility = this.mapControlService.eventVisibility;
        this.events = res;
      }
    });

    this.mapControlService.callForMapLoader$.pipe(skip(1)).subscribe((res) => {
      this.clearEventLoops();
      this.setVehicleAtTime(res.time);
    });

    this.mapControlService.startCall$.subscribe((startTripBool) => {
      if (this.mapControlService.isTripEnded) {
        this.clearEventLoops();
        this.mapControlService.isTripEnded = false;
        if (this.noInternetAnimation) {
          clearInterval(this.noInternetAnimation);
          this.busImageURL = `${this.replayImgSrc}assets/icons/cab-on-map.svg`;
          this.noInternetAnimation = null;
        }
      }
      if (startTripBool) {
        this.startTrip();
      }
    });
  }

  ngAfterViewInit() {
    this.showMapLoader=true;
    setTimeout(() => {
      this.map?.setZoom(this.map.getZoom() - 2);
      this.map?.setCenter(
        this.mapControlService.shuttleStopMarkerList[
          Math.max( Math.floor(this.mapControlService.shuttleStopMarkerList.length / 2) -
          1,0)
        ].getPosition()  
      );
      this.commonService.fixedToEnd.next(true);
      this.tripEnded = true;
      this.showMapLoader=false;
    }, 500);
    this.createSpeedometerChart();
    this.vehicleStoppageIndexes = this.eventLogicService.getEvent('vehicle-stoppage');
    this.sosArrayRes = this.eventLogicService.getEvent('sos');
    this.seatBeltArray = this.eventLogicService.getEvent('seat-belt');
    this.overspeedingIntervals =
      this.eventLogicService.getEvent('overspeeding');
    this.networkLossIntervals = this.eventLogicService.getEvent('network-loss');
    this.deviceOffIntervals = this.eventLogicService.getEvent('device-off');
    this.gpsLossIntervals = this.eventLogicService.getEvent('gps-loss');
    this.calcPickupDropEmpsForStops();
    this.callEmployee = this.driverData["callEmployeeDriverActions"]
    this.noShowInterval = this.driverData["noShowDriverActions"]; 
    this.vehicleArrivedIntervals = this.eventLogicService.getEvent('vehicle-arrived'); 
    // this.seatBeltIntervals = this.
    // this.calcStopsIndexes();
    this.mapInitializer();
    this.showPlannedRoute();
    this.mapControlService.restartCall$.subscribe((res) => this.plotMarkers());

    // Plotting vehicle at start
    const busImage = {
      url: `${this.replayImgSrc}assets/icons/cab-on-map.svg`,
      scaledSize: new google.maps.Size(40, 40),
      anchor: new google.maps.Point(13, 13),
    };

    const firstLocation = this.locationList?.[0];
    if (firstLocation && isValidCoordinate(firstLocation.latitude, firstLocation.longitude)) {
      this.mapControlService.mapVehicleMarker = new google.maps.Marker({
        position: new google.maps.LatLng(
          firstLocation.latitude,
          firstLocation.longitude
        ),
        map: this.map,
        icon: busImage,
      });
    }

  // Create the InfoWindow content with a close button
  const infoWindowContent = `
    <div style="position: relative; padding: 10px; width: 200px;">
      <button id="close-info-window" style="position: absolute; top: 5px; right: 5px; cursor: pointer; background: none; border: none; font-size: 18px;">&#10005;</button>
      <div style="padding-top: 25px;">
        <span style="padding-top: 5px;">Cab Number: ${this.tripDetails.vehicle.vehicleIdentification}</span>
        <br/>
        <span style="padding-top: 8px;">Driver: ${this.tripDetails.driver?.name}</span>
      </div>
    </div>
  `;

  const infoWindow = new google.maps.InfoWindow({
    content: infoWindowContent,
  });

  // Add a click event listener to the marker
  if(this.mapControlService.mapVehicleMarker){
  this.mapControlService.mapVehicleMarker.addListener('click', () => {
    // Open the InfoWindow
    infoWindow.open(this.map, this.mapControlService.mapVehicleMarker);

    // Wait until the DOM is rendered, then add the event listener for the close button
    setTimeout(() => {
      const closeButton = document.getElementById('close-info-window');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          infoWindow.close();
        });
      }
    }, 0);
  });
}

    let elemSel = document.querySelector(
      'img[src*="cab-on-map.svg"]'
    ) as HTMLElement; 
    

  }
  plotNoShow(noShow, location, indexMile) {
     const noShowGeoCodesMap = (noShow ?? [])?.filter(obj => obj?.geoCode).map((obj: any) => {
      const [lat, lng] = obj.geoCode.split(",");
      const position = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
      return {
        time: obj.markedAt,
        position,
        empName: obj.empName,
        employeeId: obj.empId,
        markedAt: DateUtils.formatTime(obj?.markedAt, 'hh:mm'),
        plannedAt: obj.plannedLocation.address,
        markedBy: obj.markedBy,
        proximity: obj.proximity
      };
    });
  
    const icon = {
      url: `${this.replayImgSrc}assets/icons/no-show-on-map.svg`,
      scaledSize: new google.maps.Size(60, 60),
      labelOrigin: new google.maps.Point(40, 40),
    };
  
    for (let i = 0; i < noShowGeoCodesMap?.length; i++) {
    if (indexMile >= 0 && (
      (indexMile === 0 && noShowGeoCodesMap[i].time < this.locationList[0].time) ||
      (indexMile > 0 && noShowGeoCodesMap[i].time >= this.locationList[indexMile - 1].time && noShowGeoCodesMap[i].time <= this.locationList[indexMile].time)
    )){
        const marker = new google.maps.Marker({
          position: noShowGeoCodesMap[i].position,
          map: this.map,
          icon: icon,
        });
  
        // Create the circle
        const circle = new google.maps.Circle({
          strokeColor: "#E57373",
          strokeOpacity: 0.8,
          strokeWeight: 1,
          fillColor: "#FFCDD2",
          fillOpacity: 0.4,
          map: this.map,
          center: noShowGeoCodesMap[i].position,
          radius:this.commonService.DRIVER_APP_PROPERTIES['NO_SHOW_BTN_GEO_FENCE']
        });
  
        let openTooltip: any = null;
  
        // Custom tooltip with close button
        const tooltipContent = `
          <div class="no-show-tooltip" style="position: relative;">
            <button id="close-info-window" style="position: absolute; top: 5px; right: 5px; cursor: pointer; background: none; border: none; font-size: 18px;">&#10005;</button>
            <div>
              <h2 class="red">No Show</h2>
              <p class="h7"><span>Marked For</span> : ${noShowGeoCodesMap[i]?.empName}</p>
              <p class="h7"><span>Employee ID</span> : ${noShowGeoCodesMap[i]?.employeeId}</p>
              <p class="h7"><span>Marked at</span> : ${DateUtils.formatTimeWithZone(noShowGeoCodesMap[i]?.time, this.commonService.timeZone, "LT")}</p>
              <p class="h7"><span>Marked by</span> : ${noShowGeoCodesMap[i]?.markedBy}</p>
              <p class="h7"><span>Within Proximity</span> : ${noShowGeoCodesMap[i]?.proximity}</p>
             ${
              true &&
              `<p class="h7"><span>No Show Grace Time (Mins)</span> : ${this.commonService.DRIVER_APP_PROPERTIES['NO_SHOW_BTN_TIME']} </p>`
             }
            </div>
          </div>
        `;
  
        const infowindow = new google.maps.InfoWindow({
          content: tooltipContent,
        });
  
        marker.addListener('click', () => {
          if (openTooltip && openTooltip.marker === marker) {
            openTooltip.infowindow.close();
            openTooltip = null;
          } else {
            infowindow.open(this.map, marker);
            openTooltip = { marker, infowindow };
          }
        });
  
        google.maps.event.addListener(infowindow, 'domready', () => {
          const closeButton = document.getElementById('close-info-window');
          if (closeButton) {
            closeButton.addEventListener('click', () => {
              infowindow.close();
              openTooltip = null;
            });
          }
        });
  
        this.map.addListener('click', () => {
          if (openTooltip) {
            openTooltip.infowindow.close();
            openTooltip = null;
          }
        });
  
        // Store markers and circles for reference
        this.mapControlService.noshowMarkerList.push(marker);
        this.mapControlService.noshowCircleList.push(circle);
      }
    }
  }
  
  
  plotCallEmployeeMarkersOnMap(location) {
    // Extract all the geoCode values
    const callEmployeesGeoCodesMap = this.callEmployee?.
    filter((obj: any) => obj && obj.geoCode)
    ?.map((obj: any) => {
      const [lat, lng] = obj.geoCode.split(",");
      const position = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
      return {
        position,
        empName: obj.empName,
        empId: obj.empId,
        pickUp: DateUtils.formatTime(obj.pickUpTime, "hh:mm"),
        callNumber: obj.phoneNumber,
        callStart: DateUtils.formatTimeWithZone(obj.callStartTime, this.commonService.timeZone, 'LT'),
        callDuration: obj.callDuration,
        callStatus: obj.callStatus,
        callTime: obj.callStartTime
      };
    });
  
    const icon = {
      url: `${this.replayImgSrc}assets/icons/call-employee-marker-on-map.svg`,
    };
  
    for (let i = 0; i < callEmployeesGeoCodesMap?.length; i++) {
      if (Math.abs(callEmployeesGeoCodesMap[i].callTime - location.time) < 20000) {
        const marker = new google.maps.Marker({
          position: callEmployeesGeoCodesMap[i].position,
          map: this.map,
          icon: icon,
        });
  
        let openTooltip: any = null;
  
        // Custom tooltip with close button
        const tooltipContent = `
          <div class="call-employee-tool-tip" style="position: relative;">
            <button id="close-info-window" style="position: absolute; top: 5px; right: 5px; cursor: pointer; background: none; border: none; font-size: 18px;">&#10005;</button>
            <div>
              <h2>Driver-employee calls</h2>
              <p><span>Employee Name</span> : ${callEmployeesGeoCodesMap[i].empName}</p>
              <p><span>Call Start</span> : ${callEmployeesGeoCodesMap[i].callStart}</p>
              ${callEmployeesGeoCodesMap[i].callStatus === 'completed' ? 
                `<p><span>Call Duration</span> : ${callEmployeesGeoCodesMap[i].callDuration} sec(s)</p>` : 
                ``
              }
              <p><span>Call Status</span> : ${callEmployeesGeoCodesMap[i].callStatus}</p>
            </div>
          </div>
        `;
  
        const infowindow = new google.maps.InfoWindow({
          content: tooltipContent,
        });
  
        marker.addListener('click', () => {
          if (openTooltip && openTooltip.marker === marker) {
            openTooltip.infowindow.close();
            openTooltip = null;
          } else {
            infowindow.open(this.map, marker);
            openTooltip = { marker, infowindow };
          }
        });
  
        google.maps.event.addListener(infowindow, 'domready', () => {
          const closeButton = document.getElementById('close-info-window');
          if (closeButton) {
            closeButton.addEventListener('click', () => {
              infowindow.close();
              openTooltip = null;
            });
          }
        });
  
        this.map.addListener('click', () => {
          if (openTooltip) {
            openTooltip.infowindow.close();
            openTooltip = null;
          }
        });
  
        this.mapControlService.CallEmpMarkerList.push(marker);
      }
    }
  }
  
  clearEventLoops() {
    this.indexForMilestone = 0;
    this.formattedWaypoints = [];
    this.overspeedformattedWaypoints = [];
    this.gpsLossWaypoints = [];
    this.showOverlay = false;
    this.isOverspeeding = false;
    this.startPlottingOverspeed = false;
    this.startNetworkLoss = false;
    this.deviceOffStart = false;
    this.gpsLossStart = false;
  }
  setVehicleAtTime(time: number) {
    if (this.mapControlService.mapVehicleMarker == null) {
      const firstLocation = this.locationList?.[0];
      if (firstLocation && isValidCoordinate(firstLocation.latitude, firstLocation.longitude)) {
        this.vehicleCurrentLocationCords = new google.maps.LatLng(
          firstLocation.latitude,
          firstLocation.longitude
        );
        const bearing = firstLocation?.mBearing;
      this.vehiclePreviousCoords = {
        lat: this.vehicleCurrentLocationCords.lat(),
        lng: this.vehicleCurrentLocationCords.lng(),
      };
      const busImage = {
        url: `${this.replayImgSrc}assets/icons/cab-on-map.svg`,
        scaledSize: new google.maps.Size(40, 40),
        anchor: new google.maps.Point(13, 13),
      };

      this.mapControlService.mapVehicleMarker = new google.maps.Marker({
        position: this.vehicleCurrentLocationCords,
        map: this.map,
        icon: busImage,
      });
  // Create the InfoWindow content with a close button
  const infoWindowContent = `
    <div style="position: relative; padding: 10px; width: 200px;">
      <button id="close-info-window" style="position: absolute; top: 5px; right: 5px; cursor: pointer; background: none; border: none; font-size: 18px;">&#10005;</button>
      <div style="padding-top: 25px;">
        <span style="padding-top: 5px;">Cab Number: ${this.tripDetails.vehicle.vehicleIdentification}</span>
        <br/>
        <span style="padding-top: 8px;">Driver: ${this.tripDetails.driver?.name}</span>
      </div>
    </div>
  `;

  const infoWindow = new google.maps.InfoWindow({
    content: infoWindowContent,
  });

  const marker = this.mapControlService.mapVehicleMarker;
  if(marker){
  marker.addListener('click', () => {
    // Open the InfoWindow
    infoWindow.open(this.map, marker);

    // Wait until the DOM is rendered, then add the event listener for the close button
    setTimeout(() => {
      const closeButton = document.getElementById('close-info-window');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          infoWindow.close();
        });
      }
    }, 0);
  });
  }

      let elemSel = document.querySelector(
        'img[src*="cab-on-map.svg"]'
      ) as HTMLElement;

      if (elemSel && bearing != null) {
        elemSel.style.transform = `rotate(${bearing}deg)`;
      }
      }
    }

    // check if the vehicle moves out of map view
    if (this.mapControlService.mapVehicleMarker) {
    google.maps.event.addListener(
      this.mapControlService.mapVehicleMarker,
      'position_changed',
      () => {
        const markerPosition =
          this.mapControlService.mapVehicleMarker?.getPosition();
        const mapBounds = this.map?.getBounds();

          if (mapBounds && markerPosition && !mapBounds.contains(markerPosition)) {
            this.map?.setCenter(markerPosition);
          }
        }
      );
    }

    const currMilestone = this.locationList && this.locationList[this.indexForMilestone] ? this.locationList[this.indexForMilestone] : null;

    for (
      ;
      this.mapControlService.timer <= time;
      this.mapControlService.timer += 1000
    ) {
      while (this.indexForMilestone < this.locationList.length &&  currMilestone?.time != null &&
             this.mapControlService.timer > currMilestone?.time + 1000
      ) {
             this.indexForMilestone++;
      }
      if (
        this.indexForMilestone < this.locationList.length && currMilestone?.time &&
        Math.abs(
          currMilestone.time -
          this.mapControlService.timer
        ) < 1000
      ) {
        this.quickSetMap(this.locationList[this.indexForMilestone],this.indexForMilestone);
        this.indexForMilestone++;
        if (this.indexForMilestone == this.locationList.length) {
          this.indexForMilestone--;
        }
      }
    }
    // Set vehicle location
    if (currMilestone && this.mapControlService.mapVehicleMarker) {
      const bearing = currMilestone?.mBearing;
      var imgIcon = this.mapControlService.mapVehicleMarker?.getIcon?.();
      if(imgIcon) {
      imgIcon['rotation'] = bearing;
      }
      if (isValidCoordinate(currMilestone?.latitude, currMilestone?.longitude)) {
        this.vehiclePreviousCoords = {
          lat: currMilestone.latitude,
          lng: currMilestone.longitude,
        };
        this.mapControlService.mapVehicleMarker.setIcon(imgIcon);
        this.mapControlService.mapVehicleMarker.setPosition({
          lat: currMilestone.latitude,
          lng: currMilestone.longitude,
        });
      }
    let elemSel = document.querySelector(
      'img[src*="cab-on-map.svg"]'
    ) as HTMLElement;
    if (elemSel && bearing != null && bearing != 0) {
      elemSel.style.transform = `rotate(${bearing}deg)`;
    }

    // set speed
    const mSpeed = currMilestone?.mSpeed;
    this.vehicleSpeed = (mSpeed && isFinite(mSpeed))
      ? Math.floor(mSpeed * 3.6)
      : 0;
    if (this.vehicleSpeed > this.mapControlService.thresholdSpeed) {
      this.isOverspeeding = true;
    } else {
      this.isOverspeeding = false;
    }
  }
    const chart = Highcharts.charts[0];
    if (chart && !chart.renderer['forExport']) {
      const point = chart.series[0].points[0],
        inc = this.vehicleSpeed;

      let newVal = inc;
      // if (newVal < 0 || newVal > 200) {
      //   newVal = point.y - inc;
      // }
      this.options.series[0].dataLabels = {
        color:
          this.vehicleSpeed > this.mapControlService.thresholdSpeed
            ? '#FF0404'
            : '#333333',
      };
      chart.update(this.options);
      point.update(newVal);
    }
    this.showMapLoader = false;
  }
  createSpeedometerChart() {
    //HighCharts
    this.options = {
      chart: {
        type: 'gauge',
        plotBackgroundColor: '#F2FBFF',
        plotBackgroundImage: '#F2FBFF',
        plotBorderWidth: 0,
        plotShadow: false,
        height: '80%',
      },

      title: {
        text: 'Speed:',
      },

      pane: {
        startAngle: -90,
        endAngle: 89.9,
        background: null,
        center: ['50%', '75%'],
        size: '110%',
      },

      // the value axis
      yAxis: {
        min: 0,
        max: 200,
        tickPixelInterval: 72,
        tickPosition: 'inside',
        tickColor: Highcharts.defaultOptions.chart.backgroundColor || '#FFFFFF',
        tickLength: 15,
        tickWidth: 1,
        minorTickInterval: null,
        labels: {
          distance: 20,
          style: {
            fontSize: '12px',
          },
        },
        lineWidth: 0,
        plotBands: [
          {
            from: 0,
            to: 120,
            color: '#55BF3B', // green
            thickness: 10,
          },
          {
            from: 120,
            to: 160,
            color: '#DDDF0D', // yellow
            thickness: 10,
          },
          {
            from: 160,
            to: 200,
            color: '#DF5353', // red
            thickness: 10,
          },
        ],
      },

      series: [
        {
          name: 'Speed',
          data: [0],
          tooltip: {
            valueSuffix: ' km/h',
          },
          dataLabels: {
            format: '<b>{y}</b> km/h',
            y: 20,
            borderWidth: 0,
            color: '#333333',
            style: {
              textOutline: 'none',
              fontSize: '14px',
              fontWeight: 'normal',
            },
          },
          dial: {
            radius: '80%',
            backgroundColor: 'gray',
            baseWidth: 10,
            baseLength: '0%',
            rearLength: '0%',
          },
          pivot: {
            backgroundColor: 'gray',
            radius: 4,
          },
        },
      ],
    };
    Highcharts.chart('speedometerContainer', this.options);
  }
  startTrip() {
    if (this.mapControlService.mapVehicleMarker == null) {
      const firstLocation = this.locationList?.[0];
      if (firstLocation && isValidCoordinate(firstLocation.latitude, firstLocation.longitude)) {
        this.vehicleCurrentLocationCords = new google.maps.LatLng(
          firstLocation.latitude,
          firstLocation.longitude
        );
        const bearing = firstLocation?.mBearing;
      this.vehiclePreviousCoords = {
        lat: this.vehicleCurrentLocationCords.lat(),
        lng: this.vehicleCurrentLocationCords.lng(),
      };
      const busImage = {
        url: `${this.replayImgSrc}assets/icons/cab-on-map.svg`,
        scaledSize: new google.maps.Size(40, 40),
        anchor: new google.maps.Point(13, 13),
      };

      this.mapControlService.mapVehicleMarker = new google.maps.Marker({
        position: this.vehicleCurrentLocationCords,
        map: this.map,
        icon: busImage,
      });

      const infoWindow = new google.maps.InfoWindow({
        content: `
              <div>
                <span style="padding-top:5px">Bus Number: ${this.tripDetails.vehicle.vehicleIdentification}</span>
                <br/>
                <span style="padding-top:8px;">Driver: ${this.tripDetails.driver?.name}</span>
              </div>`,
      });

      // Add click event listener to the marker
      this.mapControlService.mapVehicleMarker.addListener('click', () => {
        // Open the InfoWindow
        infoWindow.open(this.map, this.mapControlService.mapVehicleMarker);
      });

      let elemSel = document.querySelector(
        'img[src*="cab-on-map.svg"]'
      ) as HTMLElement;

      if (elemSel && bearing != null) {
        elemSel.style.transform = `rotate(${bearing}deg)`;
      }
      }
    }

    // check if the vehicle moves out of map view
    if (this.mapControlService.mapVehicleMarker) {
    google.maps.event.addListener(
      this.mapControlService.mapVehicleMarker,
      'position_changed',
      () => {
        const markerPosition =
          this.mapControlService.mapVehicleMarker?.getPosition();
        const mapBounds = this.map?.getBounds();

          if (mapBounds && markerPosition && !mapBounds.contains(markerPosition)) {
            this.map?.setCenter(markerPosition);
          }
        }
      );
    }

    // Main driver function

    // SetInterval for timer
    this.mapControlService.tripInterval = setInterval(() => {
      // Playback speed is changed
      if (this.mapControlService.isSpeedChanged) {
        this.mapControlService.isSpeedChanged = false;
        clearInterval(this.mapControlService.tripInterval);
        this.intervalTime = 100 / (6 * this.mapControlService.playbackSpeed);
        this.startTrip();
      }  // Skip milestone where the difference bw mapControlService.timer & milestone time is > 1000ms
          while (this.indexForMilestone < this.locationList.length &&
            this.mapControlService.timer > this.locationList[this.indexForMilestone].time + 1000
              ) this.indexForMilestone++;
      // If milestone for near timer
      if (
        this.indexForMilestone < this.locationList.length &&
        Math.abs(
          this.locationList[this.indexForMilestone].time -
          this.mapControlService.timer
        ) < 1000
      ) {
        this.tripEnded = false;
        this.setVehicleMarker(this.locationList[this.indexForMilestone],this.indexForMilestone);
        // Set speedometer speed
        const mSpeed = this.locationList[this.indexForMilestone]?.mSpeed;
        this.vehicleSpeed = (mSpeed && isFinite(mSpeed))
          ? Math.floor(mSpeed * 3.6)
          : 0;
        if (this.vehicleSpeed > this.mapControlService.thresholdSpeed) {
          this.isOverspeeding = true;
        } else {
          this.isOverspeeding = false;
        }
        const chart = Highcharts.charts[Highcharts.charts.length-1];
        // console.warn("speed",this.vehicleSpeed)
        if (chart && !chart.renderer['forExport']) {
          const point = chart.series[0].points[0],
            inc = this.vehicleSpeed;

          let newVal = inc;
          // if (newVal < 0 || newVal > 200) {
          //   newVal = point.y - inc;
          // }
          this.options.series[0].dataLabels = {
            color:
              this.vehicleSpeed > this.mapControlService.thresholdSpeed
                ? '#FF0404'
                : '#333333',
          };
          chart.update(this.options);
          point.update(newVal);
        }

        this.indexForMilestone += 1;
      }

      // Driver
      this.mapControlService.tripPlayer$.next(this.mapControlService.timer);
      this.mapControlService.timer += 1000; // 1000 * 60 ms = 60s in 1s
      // End trip
      if (this.mapControlService.timer >= this.tripDetails.actualEndTime) {
        clearInterval(this.mapControlService.tripInterval);
        this.mapControlService.tripPlayer$.next(this.tripDetails.actualEndTime);
        this.indexForMilestone = 0;
        this.isOverspeeding = false;
        this.resetSpeedoMeter()
        this.tripEnded = true;
        this.mapControlService.endTrip();
      }
    }, this.intervalTime);
  }

  resetSpeedoMeter () {
    const chart = Highcharts.charts[Highcharts.charts.length - 1];
    if (chart && !chart.renderer['forExport']) {
      const point = chart.series[0].points[0];
      let newVal = 0;
      this.options.series[0].dataLabels = {
        color:
          this.vehicleSpeed > this.mapControlService.thresholdSpeed
            ? '#FF0404'
            : '#333333',
      };
      chart.update(this.options);
      point.update(newVal);
    }
  }
  geofenceHittingCircle(position: any, type: string) {
    this.circleRadius = 0;
    this.circleOpacity = 0.24;
    this.geofenceMarker = new google.maps.Circle({
      fillColor: type === 'right-time' ? '#25FF01' : '#FF0101',
      fillOpacity: this.circleOpacity,
      strokeColor: '#fff',
      strokeOpacity: 0,
      map: this.map,
      center: position,
      radius: this.circleRadius,
    });

    this.mapControlService.geofenceCirclesList.push(this.geofenceMarker);

    const animationInterval = setInterval(() => {
      this.circleRadius += 5;
      this.geofenceMarker.setRadius(this.circleRadius);
      if (this.circleRadius > 500) {
        clearInterval(animationInterval);
        const fadeInterval = setInterval(() => {
          if (this.geofenceMarker.get('fillOpacity') > 0) {
            this.circleOpacity = this.geofenceMarker.get('fillOpacity') - 0.01;
            this.geofenceMarker.set(
              'fillOpacity',
              Math.max(0, this.circleOpacity)
            );
          } else {
            clearInterval(fadeInterval);
          }
        }, 10);
      }
    }, 5);
  }
  quickSetMap(location: any, indexMile: number) {
    // Get location position
    const vehiclePosition = new google.maps.LatLng(location.latitude, location.longitude);
  
    this.plottingPolyLine(this.map, this.startPlottingOverspeed, this.gpsLossStart, this.deviceOffStart);
  
    // Manage GPS Loss
    this.handleGPSLoss(location, vehiclePosition);
  
    // Manage Device Off event
    this.handleDeviceOff(location, vehiclePosition, indexMile);
  
    // Manage Network Loss event
    this.handleNetworkLoss(location, vehiclePosition, indexMile);
  
    // Manage Overspeeding event
    this.handleOverspeeding(location, vehiclePosition, indexMile);
  
    // Additional functions for no-show and call employee markers
    this.plotNoShow(this.noShowInterval, location, indexMile);
    this.plotCallEmployeeMarkersOnMap(location);
    // Set vehicle stoppage markers
    if (this.vehicleStoppageIndexes?.length) {
      this.plotVehicleStoppageMarkers(location, indexMile);
    }

    // Vehicle arrived markers
    if(this.vehicleArrivedIntervals.length){
      this.plotVehicleArrivedMarkers(location, indexMile, vehiclePosition);
    }

    // SOS Event handling
    if (this.sosArrayRes.length) {
      this.plotSOSMarkers(location, indexMile, vehiclePosition);
    }

    // Seat Belt Event handling
    if (this.seatBeltArray.length) {
      this.plotSeatBeltMarkers(location, indexMile, vehiclePosition);
    }
  
    // Geofence hitting for employee pickup/drop
    this.handleGeofenceHitting(location);
  
    // Main polyline update for vehicle path
    this.formattedWaypoints.push(vehiclePosition);

    if (this.deviceOffStart || this.gpsLossStart) {
      // Add buffer for main polyline if there's an event
      this.mapControlService.polylineList.push(new google.maps.Polyline());
      this.formattedWaypoints = [];
    }
    // Move vehicle on the map
    // this.moveVehicleMarker(location, vehiclePosition);
  }
  setVehicleMarker(location: any, indexMile: number) {
    // Get location position
    const vehiclePosition = new google.maps.LatLng(location.latitude, location.longitude);

    this.plottingPolyLine(this.map, this.startPlottingOverspeed, this.gpsLossStart ,this.deviceOffStart);
  
    // Manage GPS Loss
    this.handleGPSLoss(location, vehiclePosition);
  
    // Manage Device Off event
    this.handleDeviceOff(location, vehiclePosition,indexMile);
  
    // Manage Network Loss event
    this.handleNetworkLoss(location, vehiclePosition, indexMile);
  
    // Manage Overspeeding event
    this.handleOverspeeding(location, vehiclePosition, indexMile);
  
    // Additional functions for no-show and call employee markers
    this.plotNoShow(this.noShowInterval, location, indexMile);

    this.plotCallEmployeeMarkersOnMap(location);

    // Vehicle arrived markers
    if(this.vehicleArrivedIntervals.length){
      this.plotVehicleArrivedMarkers(location, indexMile, vehiclePosition);
    }
  
    // Set vehicle stoppage markers
    if (this.vehicleStoppageIndexes?.length) {
      this.plotVehicleStoppageMarkers(location, indexMile);
    }
  
    // SOS Event handling
    if (this.sosArrayRes.length) {
      this.plotSOSMarkers(location, indexMile, vehiclePosition);
    }

    // Seat Belt Event handling
    if (this.seatBeltArray.length) {
      this.plotSeatBeltMarkers(location, indexMile, vehiclePosition);
    }
  
    // Geofence hitting for employee pickup/drop
    this.handleGeofenceHitting(location);

    // Main polyline update for vehicle path
    this.formattedWaypoints.push(vehiclePosition);

    if (this.deviceOffStart || this.gpsLossStart) {
      // Add buffer for main polyline if there's an event
      this.mapControlService.polylineList.push(new google.maps.Polyline());
      this.formattedWaypoints = [];
    }
  
    // Move vehicle on the map
    this.moveVehicleMarker(location, vehiclePosition);
  }
  handleGPSLoss(location: any, vehiclePosition: google.maps.LatLng) {
    // Check if GPS loss event visibility is enabled
    const isGPSLossVisible = this.eventVisibility.get('no-gps') ?? false;
  
    // If GPS loss is currently active and GPS loss visibility is enabled
    if (this.gpsLossStart && isGPSLossVisible) {
      this.gpsLossWaypoints.push(vehiclePosition);
      this.plottingPolyLine(this.map, this.startPlottingOverspeed, this.gpsLossStart, this.deviceOffStart);
      this.gpsLossWaypoints = [];
      this.gpsLossStart = false;
      this.showOverlay = false;
      
    }
  
    // Loop through GPS loss intervals to check if a GPS loss event starts at the current location's time
    this.gpsLossIntervals.forEach((interval) => {
      if (interval[0].time === location.time) {
        this.gpsLossStart = true;
  
        // Set GPS loss symbol and overlay only if visibility is enabled
        if (isGPSLossVisible) {
          this.assetPath = { '--path': `url(${this.replayImgSrc}assets/icons/gps-loss-symbol.svg)` };
          this.showOverlay = true;
        }
  
        this.gpsLossWaypoints.push(vehiclePosition);
      }
    });
  }

  handleDeviceOff(location: any, vehiclePosition: google.maps.LatLng, index:number) {
    // Check if Device Off event visibility is enabled
    const isDeviceOffVisible = this.eventVisibility.get('device-off') ?? false;
  
    // If Device Off is currently active and visibility is enabled
    if (this.deviceOffStart) {
      if (isDeviceOffVisible && this.currentDeviceOff) {
        // Add waypoint and plot polyline for Device Off only if visibility is enabled
        this.deviceOffWaypoints.push(vehiclePosition);
        this.plottingPolyLine(this.map, this.startPlottingOverspeed, this.gpsLossStart, this.deviceOffStart);
        this.deviceOffWaypoints = [];
      }
  
      // Reset device off state
      this.deviceOffStart = false;
      this.showOverlay = false;
      this.cdr.detectChanges();

      // Create end marker for the Device Off event
      // this.createDeviceOffEndMarker(vehiclePosition, location);
      this.currentDeviceOff = null; // Clear current interval after ending
    }
  
    // Loop through Device Off intervals to check if a Device Off event starts at the current location's time
    this.deviceOffIntervals?.forEach((interval) => {
      // Only start a new Device Off event if we're not already within this interval
      if (interval !== this.currentDeviceOff && interval[2] === location.time) {
        this.deviceOffStart = true;
        this.currentDeviceOff = interval; // Set the current interval
  
        // Add waypoint and set overlay only if visibility is enabled
        if (isDeviceOffVisible) {
          this.deviceOffWaypoints.push(vehiclePosition);
          this.assetPath = { '--path': 'url(../../../../assets/icons/device-off-symbol.svg)' };
          this.showOverlay = true;
        }
  
        // this.createDeviceOffStartMarker(vehiclePosition, interval);
      }
    });
  }
  
  handleNetworkLoss(location: any, vehiclePosition: google.maps.LatLng ,index:number) {
    let currentTime = this.locationList[index].time;
    if(this.mapControlService.isTripEnded) {
      currentTime = this.locationList[this.locationList.length - 1].time
    }
    this.clearNetworkLossPolylines();
    if(this.eventVisibility.get('no-network-start')) {
      this.networkLossIntervals.forEach((interval) => {
        const [startTime, endTime] = interval;
        let intervalWaypoints: google.maps.LatLng[] = [];
          //  draw all past intervals with waypoints up to the current time
          if (endTime <= currentTime) {
            intervalWaypoints = this.locationList
              .filter(location => location.time >= startTime && location.time <= endTime)
              .map(location => new google.maps.LatLng(location.latitude, location.longitude));
            this.plottingPolyLineForNetworkLoss(this.map, intervalWaypoints, '#994443'); 
          }
        if (currentTime >= startTime && currentTime <= endTime) {
          const mileStoneItemsIntervalForNetworkLoss = this.locationList.filter(mileStoneItem => mileStoneItem.time >= startTime && mileStoneItem.time <= currentTime).map(mileStoneItem => new google.maps.LatLng(mileStoneItem.latitude, mileStoneItem.longitude));
          this.plottingPolyLineForNetworkLoss(this.map, mileStoneItemsIntervalForNetworkLoss, '#994443');
        } 
      });
    }
  }
  plottingPolyLineForNetworkLoss(map: google.maps.Map, waypoints: google.maps.LatLng[], color: string) {
    const networkLossPolyline = new google.maps.Polyline({
      path: waypoints,
      geodesic: true,
      strokeColor: color,
      strokeOpacity: 1.0,
      strokeWeight: 6,
      zIndex: 100,
    });
  
    networkLossPolyline.setMap(map); // Add polyline to the map
    this.mapControlService.networkLossPolylineList.push(networkLossPolyline); // Store polyline for future reference
  }
  clearNetworkLossPolylines() {
    this.mapControlService.networkLossPolylineList.forEach(polyline => polyline.setMap(null)); 
    this.mapControlService.networkLossPolylineList = []; 
  }
  
  overSpeedingThreshold:number = this.commonService.overSpeedingThreshold;
  startPlottingOverspeeding:boolean = false;
  listOfOverspeedingGeoCoords:any[] = [];
  overspeedStartTime:any;
  overspeedEndTime:any;
  previousMilestoneTime :any;
  private currentOverspeedPolyline: google.maps.Polyline | null = null;
  private currentOverspeedPath: google.maps.LatLng[] = [];
  infoWindow: google.maps.InfoWindow = new google.maps.InfoWindow();


handleOverspeeding(location: any, vehiclePosition: google.maps.LatLng, index: number) {
    const currentLeg = this.locationList[index] || null;
    if (!currentLeg || !currentLeg.latitude || !currentLeg.longitude) {
        console.warn("Invalid GPS data, skipping overspeed processing.");
        return;
    }

    const speedKmph = currentLeg.mSpeed * 3.6;
    const isOverspeeding = speedKmph > this.overSpeedingThreshold;

    if (isOverspeeding) {
        // Start new overspeed segment
        if (!this.startPlottingOverspeeding) {  
            this.startPlottingOverspeeding = true;
            this.overspeedStartTime = currentLeg.time;
            this.currentOverspeedPath = [];
            this.listOfOverspeedingGeoCoords = [];
            this.previousMilestoneTime = currentLeg.time;

            this.currentOverspeedPolyline = new google.maps.Polyline({
                path: this.currentOverspeedPath,
                geodesic: true,
                strokeColor: '#ED323B',
                zIndex: 100,
                strokeWeight: this.strokeWidth,
            });
            (this.currentOverspeedPolyline as any)._overspeedStartTime = this.overspeedStartTime;
            (this.currentOverspeedPolyline as any)._overspeedEndTime = null;

            this.mapControlService.overSpeedPolylineList.push(this.currentOverspeedPolyline);
            this.currentOverspeedPolyline.setMap(this.map);

            // Start pulsating animation
            this.polylineAnimationList.forEach(animation => clearInterval(animation));
            const polylineAnimation = setInterval(() => {
                if (!this.currentOverspeedPolyline) return;
                this.strokeWidth = this.increasing
                    ? Math.min(this.strokeWidth + 1, this.maxStrokeWidth)
                    : Math.max(this.strokeWidth - 1, 2);
                this.increasing = this.strokeWidth === this.maxStrokeWidth ? false : this.strokeWidth === 2 ? true : this.increasing;
                this.currentOverspeedPolyline.setOptions({ strokeWeight: this.strokeWidth });
            }, 100);
            this.polylineAnimationList.push(polylineAnimation);
        }

        // Append new point to path
        const latLng = new google.maps.LatLng(currentLeg.latitude, currentLeg.longitude);
        this.currentOverspeedPath.push(latLng);
        this.listOfOverspeedingGeoCoords.push(latLng);

        if (this.currentOverspeedPolyline) {
            this.currentOverspeedPolyline.setPath(this.currentOverspeedPath);
            (this.currentOverspeedPolyline as any)._overspeedEndTime = currentLeg.time;
        }

        this.previousMilestoneTime = currentLeg.time;

        if (this.currentOverspeedPolyline) {
            const polyline = this.currentOverspeedPolyline as any;

            google.maps.event.clearListeners(polyline, 'mouseover');
            google.maps.event.clearListeners(polyline, 'mouseout');

            polyline.addListener('mouseover', (event: any) => {
                const startTime = polyline._overspeedStartTime;
                const endTime = polyline._overspeedEndTime ?? startTime;
                const duration = (endTime - startTime) / 1000;
                const isDashed = duration < this.commonService.graceTime;
                const infoTitle = isDashed ? "Potential Overspeeding" : "Overspeeding";

                const formatDuration = (secs: number) => {
                    if (secs >= 60) {
                        const m = Math.floor(secs / 60);
                        const s = Math.floor(secs % 60);
                        return `${m} min ${s} sec`;
                    }
                    return `${secs.toFixed(1)} seconds`;
                };

                const overspeedContent = `
                    <div style="width:200px;">
                        <h3>${infoTitle}</h3>
                        <p><b>Threshold:</b> ${this.overSpeedingThreshold} kmph</p>
                        <p><b>Grace Time:</b> ${this.commonService.graceTime} seconds</p>
                        <p><b>Start:</b> ${DateUtils.formatTimeWithZone(startTime,this.commonService.timeZone, 'hh:mm:ss')}</p>
                        <p><b>End:</b> ${DateUtils.formatTimeWithZone(endTime,this.commonService.timeZone, 'hh:mm:ss')}</p>
                        <p><b>Duration:</b> ${formatDuration(duration)}</p>
                    </div>
                `;
                this.infoWindow.setContent(overspeedContent);
                this.infoWindow.setPosition(event.latLng);
                this.infoWindow.open(this.map);
            });

            polyline.addListener('mouseout', () => {
                this.infoWindow.close();
            });
        }

    } else {
        // Not overspeeding now
        if (this.startPlottingOverspeeding) {
            this.startPlottingOverspeeding = false;
            this.overspeedEndTime = this.previousMilestoneTime || currentLeg.time;

            if (this.currentOverspeedPolyline) {
                const polyline = this.currentOverspeedPolyline as any;
                polyline._overspeedEndTime = this.overspeedEndTime;

                const duration = (polyline._overspeedEndTime - polyline._overspeedStartTime) / 1000;
                const isDashed = duration < this.commonService.graceTime;

               if (isDashed) {
              polyline.setOptions({
                  strokeWeight: 3,
                  strokeColor: '#ED323B', 
                  icons: [{
                icon: {
                    path: 'M 0,-1 0,1',
                    strokeWeight: 2,
                    strokeOpacity: 1,
                    strokeColor: '#fde6e7', 
                    scale: 3
                      },
                      offset: '0',
                      repeat: '10px'
                  }]
              });
          } else {
              polyline.setOptions({
                  strokeWeight: 4,
                  strokeColor: '#ED323B',
                  icons: [] 
              });
          }
            }

            this.polylineAnimationList.forEach(animation => clearInterval(animation));
            this.polylineAnimationList = [];
            this.currentOverspeedPolyline = null;
            this.currentOverspeedPath = [];
            this.overspeedStartTime = null;
            this.overspeedEndTime = null;
            this.previousMilestoneTime = null;
            this.listOfOverspeedingGeoCoords = [];
        }
    }
}



 createDeviceOffStartMarker(position: google.maps.LatLng, interval: any) {
    let deviceNotConnectedMarker = new google.maps.Marker({
      position,
      animation: google.maps.Animation.BOUNCE,
      map: this.eventVisibility.get('device-off') ? this.map : null,
      icon: 'assets/icons/device-off.svg',
      zIndex: 100,
    });
  
    const tooltipContent = `
      <div class="custom-tooltip">
        <h3>Device Off</h3>
       <p>Duration: ${DateUtils.formatTime(interval[0], 'hh:mm')} - ${DateUtils.formatTime(interval[1], 'hh:mm')}</p>

        <p>Length: ${interval[3]} minutes</p>
      </div>
    `;
    const deviceOffInfoWindow = new google.maps.InfoWindow({ content: tooltipContent });
  
    deviceNotConnectedMarker.addListener('click', () => {
      deviceOffInfoWindow.open(this.map, deviceNotConnectedMarker);
    });
  
    this.map.addListener('click', () => {
      deviceOffInfoWindow.close();
    });
  
    this.mapControlService.deviceNotConnectedMarkerList.push(deviceNotConnectedMarker);
  
    setTimeout(() => {
      deviceNotConnectedMarker.setAnimation(null);
    }, 100);
  }
  
  createDeviceOffEndMarker(position: google.maps.LatLng, location: any) {
    let deviceNotConnectedMarker = new google.maps.Marker({
      position,
      animation: google.maps.Animation.BOUNCE,
      map: this.eventVisibility.get('device-off') ? this.map : null,
      icon: 'assets/icons/device-off.svg',
      zIndex: 100,
    });
  
    const tooltipContent = `
      <div class="custom-tooltip">
        <h3>Device Off</h3>
        <p>Duration: ${DateUtils.formatTime(this.currentDeviceOff[0], 'hh:mm')} - ${DateUtils.formatTime(this.currentDeviceOff[1], 'hh:mm')}</p>
        <p>Length: ${this.currentDeviceOff[3]} minutes</p>
      </div>
    `;
    const deviceOffInfoWindow = new google.maps.InfoWindow({ content: tooltipContent });
  
    deviceNotConnectedMarker.addListener('click', () => {
      deviceOffInfoWindow.open(this.map, deviceNotConnectedMarker);
    });
  
    this.map.addListener('click', () => {
      deviceOffInfoWindow.close();
    });
  
    this.mapControlService.deviceNotConnectedMarkerList.push(deviceNotConnectedMarker);
  
    setTimeout(() => {
      deviceNotConnectedMarker.setAnimation(null);
    }, 100);
  }
  
  startNetworkLossMarker(position: google.maps.LatLng) {
    const noNetworkMarker = new google.maps.Marker({
      position,
      animation: google.maps.Animation.BOUNCE,
      map: this.map,
      icon: `${this.replayImgSrc}assets/icons/no-network-start.svg`,
      zIndex: 100,
    });
  
    this.addMarkerTooltip(noNetworkMarker, 'Network Loss Started', this.map, this.mapControlService.timer);
    this.mapControlService.noNetworkMarkerList.push(noNetworkMarker);
  
    this.noInternetAnimation = setInterval(() => {
      this.busImageURL = this.busImageURL === `${this.replayImgSrc}assets/icons/cab-on-map.svg`
        ? `${this.replayImgSrc}assets/icons/no-network-cab-on-map.svg`
        : `${this.replayImgSrc}assets/icons/cab-on-map.svg`;
    }, 500);
  }
  
  endNetworkLossMarker(location: any) {
    clearInterval(this.noInternetAnimation);
    this.busImageURL = `${this.replayImgSrc}assets/icons/cab-on-map.svg`;
    this.noInternetAnimation = null;
  
    const noNetworkMarker = new google.maps.Marker({
      position: new google.maps.LatLng(location.latitude, location.longitude),
      animation: google.maps.Animation.BOUNCE,
      map: this.map,
      icon: `${this.replayImgSrc}assets/icons/no-network-end.svg`,
      zIndex: 100,
    });
  
    this.addMarkerTooltip(noNetworkMarker, 'Network Loss Ended', this.map, location.time);
    this.mapControlService.noNetworkMarkerList.push(noNetworkMarker);
  
    setTimeout(() => {
      noNetworkMarker.setAnimation(null);
    }, 100);
  }
  // Add these helper methods to your MapViewCabComponent class

  // Plot vehicle stoppage markers
  plotVehicleStoppageMarkers(location: any, indexMile: number) {
    if (this.vehicleStoppageIndexes?.length) {
      this.vehicleStoppageIndexes.forEach((loc) => {
        if (indexMile > 0 && loc.startTime >= this.locationList[indexMile - 1].time && loc.startTime < this.locationList[indexMile].time) {
          let vehicleStopageMarker = new google.maps.Marker({
            position: new google.maps.LatLng(location.latitude, location.longitude),
            map: this.eventVisibility.get('vehicle-stoppage') ? this.map : null,
            icon: 'assets/icons/vehicle-stoppage.svg',
            zIndex: 100,
          });
  
          const vehicleStoppageTooltipContent = `
            <div class="vehicle-stoppage-tooltip" style="position: relative;">
              <button id="close-info-window" style="position: absolute; top: 5px; right: 5px; cursor: pointer; background: none; border: none; font-size: 18px;">&#10005;</button>
              <div>
                <h2>Vehicle Stoppage</h2>
                <p><span>Alert Status</span>: ${loc.status}</p>
                <p><span>Alert severity</span>: ${loc.alertSeverity}</p>
                <p><span>Duration</span>: ${DateUtils.formatTime(loc.startTime, 'hh:mm')} - ${DateUtils.formatTime(loc.endTime, 'hh:mm')}</p>

              </div>   
            </div>
          `;
  
          const vehicleStoppageInfoWindow = new google.maps.InfoWindow({
            content: vehicleStoppageTooltipContent,
          });
  
          vehicleStopageMarker.addListener('click', () => {
            vehicleStoppageInfoWindow.open(this.map, vehicleStopageMarker);
          });
  
          google.maps.event.addListener(vehicleStoppageInfoWindow, 'domready', () => {
            const closeButton = document.getElementById('close-info-window');
            if (closeButton) {
              closeButton.addEventListener('click', () => {
                vehicleStoppageInfoWindow.close();
              });
            }
          });
  
          this.map.addListener('click', () => {
            vehicleStoppageInfoWindow.close();
          });
  
          this.mapControlService.vehicleStoppageMarkerList.push(vehicleStopageMarker);
        }
      });
    }
  }
  

  // Plot SOS markers
  plotSOSMarkers(location: any, indexMile: number, vehiclePosition: google.maps.LatLng) {
    if (this.sosArrayRes.length) {
      this.sosArrayRes.forEach((loc) => {
        let currentInfoWindow: google.maps.InfoWindow | null = null;
        if (indexMile > 0 && loc.time >= this.locationList[indexMile - 1].time && loc.time < this.locationList[indexMile].time) {
          const sosMarker = new google.maps.Marker({
            position: vehiclePosition,
            map: this.eventVisibility.get('sos') ? this.map : null,
            icon: 'assets/icons/sos.svg',
            zIndex: 102,
          });
  
          const tooltipContent = `
            <div class="sos-marker-tooltip" style="position: relative;">
              <button id="close-info-window" style="position: absolute; top: 5px; right: 5px; cursor: pointer; background: none; border: none; font-size: 18px;">&#10005;</button>
              <div>
                <h2>SOS Alert</h2>
                <p><span>Alert Status</span>: ${loc.status}</p>
                <p><span>Alert Severity</span>: ${
                  loc.alertSeverity === 'NA' ? 'Not Defined' : loc.alertSeverity
                }</p>
                <p><span>Raised at </span>: ${DateUtils.formatTimeWithZone(loc.startTime, this.commonService.timeZone, 'LT')}</p
                <p><span>Raised From</span>: ${loc.raisedFrom}</p>
              </div>    
            </div>
          `;
  
          const infoWindow = new google.maps.InfoWindow({ content: tooltipContent });
          
          google.maps.event.addListener(infoWindow, 'domready', () => {
            const closeButton = document.getElementById('close-info-window');
            if (closeButton) {
              closeButton.addEventListener('click', () => {
                infoWindow.close();
                currentInfoWindow = null;
              });
            }
          });
  
          sosMarker.addListener('click', () => {
            if (currentInfoWindow) {
              currentInfoWindow.close();
            }
  
            if (currentInfoWindow !== infoWindow) {
              infoWindow.open(this.map, sosMarker);
              currentInfoWindow = infoWindow;
            } else {
              currentInfoWindow = null;
            }
          });
  
          this.map.addListener('click', () => {
            if (currentInfoWindow) {
              currentInfoWindow.close();
              currentInfoWindow = null;
            }
          });
  
          setTimeout(() => {
            sosMarker.setAnimation(null);
          }, 100);
  
          this.giveVehiclePause();
          this.mapControlService.sosMarkerList.push(sosMarker);
        }
      });
    }
  }
  plotSeatBeltMarkers(location: any, indexMile: number, vehiclePosition: google.maps.LatLng) {
    if (this.seatBeltArray.length) {
      this.seatBeltArray.forEach((loc) => {
        let currentInfoWindow: google.maps.InfoWindow | null = null;
        
        // Check if the seatbelt event time is within the location list time range
        const firstLocationTime = this.locationList[0].time;
        const lastLocationTime = this.locationList[this.locationList.length - 1].time;
        const fiveMinutesInMs = 5 * 60 * 1000; // 5 minutes in milliseconds
        
        // Check if the seatbelt event time is within 5 minutes of the location list time range
        const isWithinTimeRange = 
          (indexMile === 0 && loc.startTime >= firstLocationTime - fiveMinutesInMs && loc.startTime <= lastLocationTime + fiveMinutesInMs) ||
          (indexMile > 0 && loc.startTime >= this.locationList[indexMile - 1].time && loc.startTime < this.locationList[indexMile].time);
        
        if (isWithinTimeRange) {
          const seatBeltMarker = new google.maps.Marker({
            position: vehiclePosition,
            map: this.eventVisibility.get('seat-belt-worn') ? this.map : null,
            icon:loc.seatBeltStatus ? 'assets/icons/seat-belt-worn.svg' : 'assets/icons/seat-belt-not-worn.svg',
            zIndex: 102,
          });
  
          const tooltipContent = `
            <div class="sos-marker-tooltip" style="position: relative;">
              <button id="close-info-window" style="position: absolute; top: 5px; right: 5px; cursor: pointer; background: none; border: none; font-size: 18px;">&#10005;</button>
              <div>
                <h2>Seat Belt Status</h2>
                <p><span>Employee Name</span>: ${this.tripDetails?.employees?.find((d)=>{return d?.stwId=== Number(loc?.stwId)})?.name || '---'}</p>
                <p><span>Status</span>: ${ loc.seatBeltStatus ? 'Fastened' : 'Removed' } </p>
                <p><span>Confirmed at </span>: ${DateUtils.formatTimeWithZone(loc.startTime, this.commonService.timeZone, 'LT')}</p>
              </div>    
            </div>
          `;
  
          const infoWindow = new google.maps.InfoWindow({ content: tooltipContent });
          
          google.maps.event.addListener(infoWindow, 'domready', () => {
            const closeButton = document.getElementById('close-info-window');
            if (closeButton) {
              closeButton.addEventListener('click', () => {
                infoWindow.close();
                currentInfoWindow = null;
              });
            }
          });
  
          seatBeltMarker.addListener('click', () => {
            if (currentInfoWindow) {
              currentInfoWindow.close();
            }
  
            if (currentInfoWindow !== infoWindow) {
              infoWindow.open(this.map, seatBeltMarker);
              currentInfoWindow = infoWindow;
            } else {
              currentInfoWindow = null;
            }
          });
  
          this.map.addListener('click', () => {
            if (currentInfoWindow) {
              currentInfoWindow.close();
              currentInfoWindow = null;
            }
          });
  
          setTimeout(() => {
            seatBeltMarker.setAnimation(null);
          }, 100);
          this.mapControlService.seatBeltMarkerList.push(seatBeltMarker);
        }
      });
    }
  }

  plotVehicleArrivedMarkers(location: any, indexMile: number, vehiclePosition: google.maps.LatLng) {
    if (this.vehicleArrivedIntervals.length) {
      this.vehicleArrivedIntervals.forEach((loc) => {
        let currentInfoWindow: google.maps.InfoWindow | null = null;
        if (indexMile > 0 && loc.startTime >= this.locationList[indexMile - 1].time && loc.startTime < this.locationList[indexMile].time) {
          const vehicleArrivedMarker = new google.maps.Marker({
            position: vehiclePosition,
            map: this.eventVisibility.get('vehicle-arrived') ? this.map : null,
            icon: 'assets/icons/vehicle-arrived-marker-on-map.svg',
            zIndex: 102,
          });
  
          const tooltipContent = `
            <div class="sos-marker-tooltip" style="position: relative;">
              <button id="close-info-window" style="position: absolute; top: 5px; right: 5px; cursor: pointer; background: none; border: none; font-size: 18px;">&#10005;</button>
              <div>
                <h2>Vehicle Arrived</h2>
                <p><span>Reached event via</span>: ${loc.reachedButtonClickType} </p>
                <p><span>Arrived at </span>: ${DateUtils.formatTimeWithZone(loc.startTime, this.commonService.timeZone, 'LT')}</p>
              </div>    
            </div>
          `;
  
          const infoWindow = new google.maps.InfoWindow({ content: tooltipContent });
          
          google.maps.event.addListener(infoWindow, 'domready', () => {
            const closeButton = document.getElementById('close-info-window');
            if (closeButton) {
              closeButton.addEventListener('click', () => {
                infoWindow.close();
                currentInfoWindow = null;
              });
            }
          });
  
          vehicleArrivedMarker.addListener('click', () => {
            if (currentInfoWindow) {
              currentInfoWindow.close();
            }
  
            if (currentInfoWindow !== infoWindow) {
              infoWindow.open(this.map, vehicleArrivedMarker);
              currentInfoWindow = infoWindow;
            } else {
              currentInfoWindow = null;
            }
          });
  
          this.map.addListener('click', () => {
            if (currentInfoWindow) {
              currentInfoWindow.close();
              currentInfoWindow = null;
            }
          });
  
          setTimeout(() => {
            vehicleArrivedMarker.setAnimation(null);
          }, 100);
          this.mapControlService.vehicleArrivedMarkerList.push(vehicleArrivedMarker);
        }
      });
    }
  }

  

  // Handle geofence hitting for employee pickup/drop
  handleGeofenceHitting(location: any) {
    if (this.geofenceHittedStops.get(location.latitude + ',' + location.longitude) !== undefined) {
      const index = this.geofenceHittedStops.get(location.latitude + ',' + location.longitude);
      const actualSigninMarker = new google.maps.Marker({
        position: new google.maps.LatLng(location.latitude, location.longitude),
        map: this.map,
        icon: {
          url: `${this.replayImgSrc}assets/icons/actual-signin.svg`,
          scaledSize: new google.maps.Size(60, 60),
          labelOrigin: new google.maps.Point(30, 20),
        },
        zIndex: 102,
        label: {
          text: index + 1 < 10 ? '0' + (index + 1) : '' + (index + 1),
          color: '#035F6B',
          fontSize: '14px',
          fontWeight: 'bold',
        },
      });

      this.infoWindowSignin = new google.maps.InfoWindow({
        content: `
          <div class="ota-otd-infobox">
            <div><b>1234567</b></div>
            <div>Planned Pickup: 10:45</div>
            <div>Signed In: 10:50</div>
            <div>Driver Reporting Time: ${DateUtils.formatTime(location.time, 'hh:mm')}</div>
            <div>Distance Travelled: 3.6 KM</div>
          </div>`,
      });

      this.infoWindowSignin.open(this.map, actualSigninMarker);

      setTimeout(() => {
        this.infoWindowSignin.close();
      }, 2000);
      this.giveVehiclePause();
    }
  }

  // Utility function to move the vehicle marker with animation
  moveVehicleMarker(location: any, vehiclePosition: google.maps.LatLng) {
    const bearing = location?.mBearing;
    let current = { lat: location.latitude, lng: location.longitude };
  
    if (this.indexForMilestone !== 0) {
      this.animatedMove(this.mapControlService.mapVehicleMarker, this.vehiclePreviousCoords, current, bearing);
    }
  
    this.vehiclePreviousCoords = current;
  }

  addMarkerTooltip(
    marker: google.maps.Marker,
    title: string,
    map: google.maps.Map,
    time: number
  ): void {
    const tooltip = new google.maps.InfoWindow({
      content: `
              <div class="ota-otd-infobox">
                <div><b>${title}</b></div>
                <div class='time'>${DateUtils.formatTime(time, 'hh:mm')}</div>
              </div>`,
    });

    marker.addListener('click', () => {
      tooltip.open(map, marker);
    });
  }

  showEmpPickupDrop(
    tripDirection: string,
    shuttleMarker: google.maps.Marker,
    empAtStop: number
  ) {
    if (empAtStop != 0) {
      let yPosition = 0;
      const texOverlay = new google.maps.Marker({
        position: shuttleMarker.getPosition(),
        map: this.map,
        icon: {
          url: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=',
          anchor: new google.maps.Point(-30, yPosition),
        },
        label: {
          className: 'emp-pickup-text',
          color: '#638fe7',
          fontWeight: 'bold',
          text: `${tripDirection === 'OUT' ? '-' : '+'}${empAtStop}`,
          fontSize: '32px',
        },
        opacity: 0,
      });

      const openAnimation = setInterval(() => {
        if (texOverlay.getOpacity() > 1) {
          texOverlay.setOpacity(1);
          clearInterval(openAnimation);

          setTimeout(() => {
            const closeAnimation = setInterval(() => {
              if (texOverlay.getOpacity() < 0) {
                texOverlay.setOpacity(0);
                clearInterval(closeAnimation);
              } else {
                texOverlay.setOpacity(texOverlay.getOpacity() - 0.1);
              }
              yPosition += 3;
              texOverlay.setIcon({
                url: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=',
                anchor: new google.maps.Point(-30, yPosition),
              });
            }, 20);
          }, 1500);
        } else {
          texOverlay.setOpacity(texOverlay.getOpacity() + 0.1);
        }
        yPosition += 3;
        texOverlay.setIcon({
          url: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=',
          anchor: new google.maps.Point(-30, yPosition),
        });
      }, 30);
    }
  }

  calcPickupDropEmpsForStops() {
    const shuttleStops = this.tripDetails.employees;
    const employees = this.tripDetails.employees;

    shuttleStops.forEach((stop, index) => {
      this.empPickupDropForStops.set(stop.nativeId, 0);
      if (stop.actualArrivalGeoCode != null && !stop.skipped) {
        this.geofenceHittedStops.set(stop.actualArrivalGeoCode, index);
      }
    });

    console.log(this.geofenceHittedStops);

    for (let employee of employees) {
      if (this.tripDetails.direction === 'OUT') {
        // Check if no show
        if (employee.actualDropLocation) {
          this.empPickupDropForStops.set(
            employee.actualDropLocation.locationId,
            this.empPickupDropForStops.get(
              employee.actualDropLocation.locationId
            ) + 1
          );
        } else {
          console.log('no show || no signin for ' + employee.employeeId);
        }
      } else {
        // Check if no show
        if (employee.actualPickupLocation) {
          this.empPickupDropForStops.set(
            employee.actualPickupLocation.locationId,
            this.empPickupDropForStops.get(
              employee.actualPickupLocation.locationId
            ) + 1
          );
        } else {
          console.log('no show || no signin for ' + employee.employeeId);
        }
      }
    }

    console.log(this.empPickupDropForStops);
  }

  showPlannedRoute() {
    this.plannedRouteToggle = !this.plannedRouteToggle;
    this.plotPlannedRoute();
    this.plotPlannedEmployees();
  }

  plotPlannedEmployees() {
    try {
      // Map to store grouped markers by coordinate
      const markerGroups = new Map();
      const infoWindow = new google.maps.InfoWindow();
  
      // Helper function to group markers by coordinates
      const addMarkerToGroup = (lat, lng, marker, content) => {
        const locationKey = `${lat},${lng}`;
        if (!markerGroups.has(locationKey)) {
          markerGroups.set(locationKey, []);
        }
        markerGroups.get(locationKey).push({ marker, content });
      };
  
      // Function to open a combined tooltip for markers at the same location
      const openCombinedTooltip = (locationKey: string, anchorMarker: google.maps.Marker) => {
        const infoWindowId = `planned_${locationKey}`;// Unique ID for infoWindow
        if (this.activeInfoWindows.has(infoWindowId)) { //Close if this Window if it is already open
          this.activeInfoWindows.get(infoWindowId).close();
          this.activeInfoWindows.delete(infoWindowId);
          return;
        }
  
        const infoWindow = new google.maps.InfoWindow();
        
        // Prepare combined content with close button
        const markersAtSameLocation = markerGroups.get(locationKey);
        const combinedContent = `
          <div style="position: relative;">
            <button class="info-window-close" data-window-id="${infoWindowId}" style="position: absolute; top: 5px; right: 5px; cursor: pointer; background: none; border: none; font-size: 18px;">&#10005;</button>
            ${markersAtSameLocation.map((item) => item.content).join("<hr>")}
          </div>
        `;
  
        // Set the content and open the InfoWindow on the clicked marker
        infoWindow.setContent(combinedContent);
        infoWindow.open(this.map, anchorMarker);
        
        this.activeInfoWindows.set(infoWindowId, infoWindow);
  
        google.maps.event.addListenerOnce(infoWindow, 'domready', () => {
          const closeButton = document.querySelector(`button[data-window-id="${infoWindowId}"]`);
          if (closeButton) {
            closeButton.addEventListener('click', () => {
              infoWindow.close();
              this.activeInfoWindows.delete(infoWindowId);
            });
          }
        });
        google.maps.event.addListener(infoWindow, 'closeclick', () => {
          this.activeInfoWindows.delete(infoWindowId);
        });
      };
  
      // Filter employees based on trip details and direction
      let plannedEmployees = this.tripDetails.employees.filter((emp) =>
        !emp.noShow &&
        !emp.adhoc &&
        (emp.plannedPickupLocation || emp.plannedDropLocation)
      );
  
      // Further filter based on direction (IN or OUT)
      if (this.tripDetails.direction === 'IN') {
        plannedEmployees = plannedEmployees.filter(emp => emp.plannedPickupLocation);
      } else if (this.tripDetails.direction === 'OUT') {
        plannedEmployees = plannedEmployees.filter(emp => emp.plannedDropLocation);
      }
  
      // Define common marker settings
      const markerIcon = {
        url: `${this.replayImgSrc}assets/icons/map-emp-pickup.svg`,
        scaledSize: new google.maps.Size(60, 60),
        labelOrigin: new google.maps.Point(30, 20),
        anchor: new google.maps.Point(30, 35),
      };
  
      // Loop through the planned employees to plot markers
      plannedEmployees.forEach((emp, index) => {
        let labelText = index + 1 < 10 ? '0' + (index + 1) : '' + (index + 1);
        const location = this.tripDetails.direction === 'OUT' ? emp.plannedDropLocation : emp.plannedPickupLocation;
  
        if (!location || !location.geocord) return; // Skip if no valid location
  
        const [lat, lng] = location.geocord?.split(',').map(coord => parseFloat(coord.trim()));
        if (isNaN(lat) || isNaN(lng)) return; // Skip if coordinates are invalid
  
        const employeePosition = new google.maps.LatLng(lat, lng);
  
        // Tooltip content for the marker
        const signInTooltipContent = `
          <div class="sign-in-employees-tooltip d-flex flex-dir-col gap-8">
            <div class="d-flex flex-dir-col">
              <span class="h7-b">${emp.name}</span>
              <span class="planned-color">Planned ${this.tripDetails.direction === 'IN' ? 'Sign In' : 'Sign Out'}</span>
            </div>
            <div class="d-flex flex-dir-col">
              <span class="h7"><span> Employee ID</span>:&nbsp;${emp.employeeId}</span>
              <span class="h7">
                   <span>Planned ${this.tripDetails.direction === 'IN' ? 'Sign In' : 'Sign Out'}</span>:&nbsp;
                  ${DateUtils.formatTimeWithZone(this.tripDetails.direction === 'IN' ? emp.plannedPickupTime : emp.plannedDropTime, this.commonService.timeZone, 'LT')}
               </span>

              <span class="h7"><span>Planned Loc</span>:&nbsp;${ this.tripDetails.direction === 'IN' ? emp.plannedPickupLocation?.address : emp.plannedDropLocation?.address}</span>
            </div>
          </div>
        `;
  
        // Create marker
        const marker = new google.maps.Marker({
          position: employeePosition,
          map: this.map,
          icon: markerIcon,
          zIndex: 101,
          label: {
            text: labelText,
            color: '#FFFFFF', // Sign In label color
            fontSize: '14px',
            fontWeight: 'bold',
          },
        });
  
        // Add marker to group
        addMarkerToGroup(lat, lng, marker, signInTooltipContent);
      });
  
      // Set click event listener for each marker in the group
      markerGroups.forEach((markers, locationKey) => {
        markers.forEach(({ marker }) => {
          marker.addListener('click', () => {
            openCombinedTooltip(locationKey, marker);
          });
        });
      });
      console.log('markers grous', markerGroups)
    } catch (error) {
      console.error("Error plotting planned employees:", error);
    }
  }
  
  

  plotPlannedRoute() {
    let shuttleStops = this.tripDetails.employees.filter((emp:any) => {
      return !emp.noShow && !emp.adhoc && emp.plannedPickupLocation
    })
    if (this.tripDetails.direction === 'IN') {
      shuttleStops = shuttleStops.filter(stop => {
        return stop.plannedPickupLocation !== null;
      });
    }

    else if (this.tripDetails.direction === 'OUT') {
      shuttleStops = shuttleStops.filter(stop => {
        return stop.plannedDropLocation !== null;
      });
    }

    if (this.tripDetails.direction === 'OUT') {
      shuttleStops = shuttleStops.sort((a, b) => {
        return a.plannedDropTime - b.plannedDropTime;
      });
    }

    else if (this.tripDetails.direction === 'IN') {
      shuttleStops = shuttleStops.sort((a, b) => {
        return a.plannedPickupTime - b.plannedPickupTime;
      })
    }

    let routeConfig = [];

    if (this.tripDetails.direction === 'IN') {
      shuttleStops.forEach((stop) => {
        const lat = stop.plannedPickupLocation.geocord?.split(',')[0];
        const lng = stop.plannedPickupLocation.geocord?.split(',')[1];
        routeConfig.push({ lat: +lat, lng: +lng });
      });
      const lat = this.tripDetails.plannedEndLocation.geocord?.split(',')[0]; // office lat
      const lng = this.tripDetails.plannedEndLocation.geocord?.split(',')[1]; // office lng
      routeConfig.push({
        lat: +lat, lng: +lng
      });
    }

    else if (this.tripDetails.direction === 'OUT') {
      shuttleStops.forEach((stop) => {
        const lat = stop.plannedDropLocation.geocord?.split(',')[0];
        const lng = stop.plannedDropLocation.geocord?.split(',')[1];
        routeConfig.push({ lat: +lat, lng: +lng });
      });

      const lat = this.tripDetails.plannedStartLocation.geocord?.split(',')[0]; // office lat
      const lng = this.tripDetails.plannedStartLocation.geocord?.split(',')[1]; // office lng
      routeConfig.push({
        lat: +lat, lng: +lng
      })
    }

    this.calculateRoute(routeConfig);
  }

  calculateRoute(coOr) {
    const directionsService = new google.maps.DirectionsService();
    const directionsRenderer = new google.maps.DirectionsRenderer({
      map: this.map,
    });

  const origin = coOr[0];
  const destination = coOr[coOr.length - 1];
    const waypoints = coOr.slice(1, coOr.length - 1).map(point => ({
    location: new google.maps.LatLng(point.lat, point.lng),
    stopover: true
  }));

   const request = {
    origin,
    destination,
    waypoints,
    optimizeWaypoints: true,
    travelMode: google.maps.TravelMode.DRIVING,
    avoidTolls: this.isAvoidTollsEnabled()
  };
   const _this = this;
    directionsService.route(request, function (response, status) {
      if (status === google.maps.DirectionsStatus.OK) {
        _this.draw(response.routes[0].legs, directionsRenderer, response);
      } else{
        console.log("Directions request failed due to " + status);
      }
    });
  }
  draw(legs, directionsRenderer, res) {
    for (let i = 0; i < legs.length; i++) {
      const steps = legs[i].steps;

      for (let j = 0; j < steps.length; j++) {
        const polyline = new google.maps.Polyline({
          path: steps[j].path,
          strokeColor: '#FF9A22',
          strokeOpacity: 0,
          zIndex: 100,
          icons: [
            {
              icon: {
                path: 'M 0,-1 0,1', // set length this is (0,-1) to (0,1)
                strokeWeight: 2,
                strokeOpacity: 1,
                scale: 3,
              },
              offset: '0',
              repeat: '10px', // Set the distance between dashes
            },
          ],
          map: this.map,
        });
        this.mapControlService.plannedPolylineList.push(polyline);
      }
      // Fix invalid property value error
      // console.log("legs",legs)
      // directionsRenderer.setDirections(legs);
    }
  }





  plotMarkers() {
    let shuttleStops = this.tripDetails.employees.filter((emp:any)=>{
      return !emp.noShow && emp.actualPickupTime
    });
    console.log(shuttleStops);

    if (this.tripDetails.direction === 'OUT') {
      shuttleStops = shuttleStops.sort((a, b) => {
        return a.actualDropTime - b.actualDropTime;
      });
    }

    else if (this.tripDetails.direction === 'IN') {
      shuttleStops = shuttleStops.sort((a, b) => {
        return a.actualPickupTime - b.actualPickupTime;
      })
    }

    let lat: number;
    let lng: number;
    let url: string;
    let labelText: string;
    let labelColor: string;


    if (this.tripDetails.direction === 'IN') {
      url = `${this.replayImgSrc}assets/icons/office-marker.svg`;
      lat = this.tripDetails.plannedEndLocation.geocord?.split(',')[0];
      lng = this.tripDetails.plannedEndLocation.geocord?.split(',')[1];
    }
    else if (this.tripDetails.direction === 'OUT') {
      url = `${this.replayImgSrc}assets/icons/cab-office-marker.svg`;
      lat = this.tripDetails.plannedStartLocation.geocord?.split(',')[0];
      lng = this.tripDetails.plannedStartLocation.geocord?.split(',')[1];
    }

    labelText = ' ';
    labelColor = "#FFFFFF";

    let markerIcon = {
      url: url,
      scaledSize: new google.maps.Size(60, 60),
      labelOrigin: new google.maps.Point(30, 20),
    }

    const position = new google.maps.LatLng(lat, lng);
    let marker = new google.maps.Marker({
      position: position,
      map: this.map,
      icon: markerIcon,
      // animation: google.maps.Animation.DROP,
      zIndex: 101,
      label: {
        text: labelText, // The number to be displayed on the marker
        color: labelColor, // Color of the label (number)
        fontSize: '14px', // Font size of the label (number)
        fontWeight: 'bold', // Font weight of the label (number)
      },
    });
        // Create a green circle around the marker with a 200-meter radius
    const circle = new google.maps.Circle({
      strokeColor: "#045E69", // Green color for the border
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#CDEAD5", // Green color for the fill
      fillOpacity: 0.35,
      map: this.map,
      center: position, // Center the circle at the marker's position
      radius: this.commonService.DRIVER_APP_PROPERTIES['LOGIN_TRIP_OVER_DISTANCE']
    });

    this.mapControlService.shuttleStopMarkerList.push(marker);
    const imgElement = document.createElement('img');

    if(this.tripDetails.direction === 'OUT'){
      if(this.tripDetails.actualStartTime == this.tripDetails.plannedStartTime + Number(this.commonService.TRIP_DELAY_LOGOUT_GRACE_SECS)){
        imgElement.src = `${this.replayImgSrc}assets/icons/time_chip_ontime.png`; // Set the path to your PNG image
      }
      else if(this.tripDetails.actualStartTime < this.tripDetails.plannedStartTime + Number(this.commonService.TRIP_DELAY_LOGOUT_GRACE_SECS)){
        imgElement.src = `${this.replayImgSrc}assets/icons/time_chip_early.png`; // Set the path to your PNG image
      }
      else{
        imgElement.src = `${this.replayImgSrc}assets/icons/time_chip_delayed.png`; // Set the path to your PNG image
      }
    }
    else {
    if(this.tripDetails.actualEndTime == this.tripDetails.plannedEndTime + Number(this.commonService.TRIP_DELAY_LOGIN_GRACE_SECS)){
      imgElement.src = `${this.replayImgSrc}assets/icons/time_chip_ontime.png`; // Set the path to your PNG image
    }
    else if(this.tripDetails.actualEndTime < this.tripDetails.plannedEndTime + Number(this.commonService.TRIP_DELAY_LOGIN_GRACE_SECS)){
      imgElement.src = `${this.replayImgSrc}assets/icons/time_chip_early.png`; // Set the path to your PNG image
    }
    else{
      imgElement.src = `${this.replayImgSrc}assets/icons/time_chip_delayed.png`; // Set the path to your PNG image
    }
  }
    imgElement.style.position = 'absolute'; // Required to position it on the map

    const overlay = new google.maps.OverlayView();

    overlay.onAdd = () => {
    const panes = overlay.getPanes();
    panes.overlayMouseTarget.appendChild(imgElement); // Append the img element to the overlay
    };

    overlay.draw = () => {
    const projection = overlay.getProjection();
    const position = projection.fromLatLngToDivPixel(marker.getPosition());

    if (position) {
      imgElement.style.left = `${position.x - imgElement.offsetWidth / 2}px`; // Center horizontally
      imgElement.style.top = `${position.y}px`; // Adjust to place the PNG exactly below the marker
    }
    };
    overlay.setMap(this.map);  
    marker.addListener('click', () => {
      
      if (this.clickedMarker === marker) {
        this.toggleDivComponent(!this.enableEmployeesDetails);
      } else {
        this.clickedMarker = marker;
        this.toggleDivComponent(true); 
      }
    });
    const markerGroups = new Map<string, { marker: google.maps.Marker, content: string }[]>();
    
    for (let i = 0; i < shuttleStops.length; i++) {
      let signInUrl = `${this.replayImgSrc}assets/icons/actual-signin.svg`;
      let signOutUrl = `${this.replayImgSrc}assets/icons/actual-signout.svg`;
      let labelText = i + 1 < 10 ? '0' + (i + 1) : '' + (i + 1);
    
      // Common marker settings for Sign In
      const signInMarkerIcon = {
        url: signInUrl,
        scaledSize: new google.maps.Size(60, 60),
        labelOrigin: new google.maps.Point(30, 20),
        anchor: new google.maps.Point(30, 35)
      };
    
      // Common marker settings for Sign Out
      const signOutMarkerIcon = {
        url: signOutUrl,
        scaledSize: new google.maps.Size(60, 60),
        labelOrigin: new google.maps.Point(30, 20),
        anchor: new google.maps.Point(30, 35)
      };
    
      // Extract coordinates for actual pickup (Sign In) and drop (Sign Out) locations
      const signInLat = shuttleStops[i]?.actualPickupLocation?.geocord?.split(',')[0];
      const signInLng = shuttleStops[i]?.actualPickupLocation?.geocord?.split(',')[1];
      const signOutLat = shuttleStops[i]?.actualDropLocation?.geocord?.split(',')[0];
      const signOutLng = shuttleStops[i]?.actualDropLocation?.geocord?.split(',')[1];
    
      
      // Create Sign In Marker
      const signInPosition = new google.maps.LatLng(parseFloat(signInLat), parseFloat(signInLng));
      let signInMarker = new google.maps.Marker({
        position: signInPosition,
        map: this.map,
        icon: signInMarkerIcon,
        zIndex: 101,
        label: {
          text: labelText,
          color: '#035F6B', // Sign In label color
          fontSize: '14px',
          fontWeight: 'bold',
        },
      });
    
      // Tooltip content for Sign In marker
      const signInTooltipContent = `
        <div class="sign-in-employees-tooltip d-flex flex-dir-col gap-8">
          <div class="d-flex flex-dir-col">
            <span class="h7-b">${shuttleStops[i]?.name}</span>
            <span class="planned-color">${shuttleStops[i]?.adhoc ? 'Adhoc' : 'Actual'} Sign In</span>
          </div>
          <div class="d-flex flex-dir-col">
            <span class="h7"><span> Employee ID</span>:&nbsp;${shuttleStops[i].employeeId}</span>
            <span class="h7"><span>Sign in</span>:&nbsp;${DateUtils.formatTimeWithZone(shuttleStops[i].actualPickupTime, this.commonService.timeZone, 'LT')}</span>
  

            <span class="h7"><span>Via</span>:&nbsp;${shuttleStops[i].signInSource}</span>
            <span class="h7"><span>Driver Reporting Time</span>:&nbsp;${DateUtils.formatTimeWithZone(shuttleStops[i].driverReportingTime, this.commonService.timeZone, 'LT')}</span>
          </div>
        </div>
      `;
    
      // Create Sign Out Marker
      const signOutPosition = new google.maps.LatLng(parseFloat(signOutLat), parseFloat(signOutLng));
      let signOutMarker = new google.maps.Marker({
        position: signOutPosition,
        map: this.map,
        icon: signOutMarkerIcon,
        zIndex: 101,
        label: {
          text: labelText,
          color: '#C13D6D', // Sign Out label color
          fontSize: '14px',
          fontWeight: 'bold',
        },
      });
    
      // Tooltip content for Sign Out marker
      const signOutTooltipContent = `
        <div class="sign-in-employees-tooltip d-flex flex-dir-col gap-8">
          <div class="d-flex flex-dir-col">
            <span class="h7-b">${shuttleStops[i]?.name}</span>
            <span class="planned-color">Actual Sign Out</span>
          </div>
          <div class="d-flex flex-dir-col">
            <span class="h7"><span>Employee ID</span>:&nbsp;${shuttleStops[i].employeeId}</span>
          <span class="h7"><span>Drop Off</span>:&nbsp;${DateUtils.formatTimeWithZone(shuttleStops[i].actualDropTime, this.commonService.timeZone, 'LT')}</span>


            <span class="h7"><span>Via</span>:&nbsp;${shuttleStops[i].signOffSource}</span>

          </div>
        </div>
      `;
    
      // Group markers by coordinates
      const addMarkerToGroup = (lat: string, lng: string, marker: google.maps.Marker, content: string) => {
        const locationKey = `${lat},${lng}`;
        if (!markerGroups.has(locationKey)) {
          markerGroups.set(locationKey, []);
        }
        markerGroups.get(locationKey).push({ marker, content });
      };
    
      addMarkerToGroup(signInLat, signInLng, signInMarker, signInTooltipContent);
      addMarkerToGroup(signOutLat, signOutLng, signOutMarker, signOutTooltipContent);
    
      // Function to open combined tooltip for markers at the same location
      const openCombinedTooltip = (locationKey: string, anchorMarker: google.maps.Marker) => {
        const infoWindowId = `actaul_${locationKey}`;
                if (this.activeInfoWindows.has(infoWindowId)) {
          this.activeInfoWindows.get(infoWindowId).close();
          this.activeInfoWindows.delete(infoWindowId);
          return;
        }

        const infoWindow = new google.maps.InfoWindow();
  
        // Prepare combined content with a single close button at the top
        const markersAtSameLocation = markerGroups.get(locationKey);
        const combinedContent = `
          <div style="position: relative;">
            <button class="info-window-close" data-window-id="${infoWindowId}" style="position: absolute; top: 5px; right: 0px; cursor: pointer; background: none; border: none; font-size: 18px;">&#10005;</button>
            ${markersAtSameLocation.map((item) => item.content).join("<hr>")}
          </div>
        `;
  
        infoWindow.setContent(combinedContent);
        infoWindow.open(this.map, anchorMarker);
        
        this.activeInfoWindows.set(infoWindowId, infoWindow);
  
        google.maps.event.addListenerOnce(infoWindow, 'domready', () => {
          const closeButton = document.querySelector(`button[data-window-id="${infoWindowId}"]`);
          if (closeButton) {
            closeButton.addEventListener('click', () => {
              infoWindow.close();
              this.activeInfoWindows.delete(infoWindowId);
            });
          }
        });
        google.maps.event.addListener(infoWindow, 'closeclick', () => {
          this.activeInfoWindows.delete(infoWindowId);
        });
      };
    
      // Set click event listener for each marker in the group
      markerGroups.forEach((markers, locationKey) => {
        markers.forEach(({ marker }) => {
          marker.addListener('click', () => {
            openCombinedTooltip(locationKey, marker);
          });
        });
      });
    
      // Add markers to their respective arrays
      this.mapControlService.SignInLocationsMarkerList.push(signInMarker);
      this.mapControlService.SignOutLocationsMarkerList.push(signOutMarker);
    }
    
  }

  toggleDivComponent(isVisible: boolean) {
    this.enableEmployeesDetails = isVisible;
  }
  onClosePopup(event){
    this.enableEmployeesDetails = false;
  }
  plottingPolyLine(map: any, isOverspeeding: boolean, isGPSLoss: boolean, isDeviceOff: boolean, isNetworkLoss?: boolean, startTime?: number, endTime?: number) {
    const infoWindow = new google.maps.InfoWindow(); // Single InfoWindow instance to reuse
    let isInfoWindowOpen = false; // Track InfoWindow open state
  
    // Main vehicle path polyline
    if (this.mapControlService.polylineList.length > 0) {
      this.mapControlService.polylineList.pop().setMap(null);
    }
    this.polyline = new google.maps.Polyline({
      path: this.formattedWaypoints,
      geodesic: true,
      strokeColor: '#4F5694',
      strokeOpacity: 1.0,
      strokeWeight: 4,
      zIndex: 98,
    });
    this.mapControlService.polylineList.push(this.polyline);
    this.polyline.setMap(map);
  
    // Function to open/close tooltip on polyline click
    const openTooltip = (polyline, content) => {
      polyline.addListener('click', (event) => {
        if (isInfoWindowOpen) {
          infoWindow.close(); // Close InfoWindow if already open
          isInfoWindowOpen = false;
        } else {
          infoWindow.setContent(content);
          infoWindow.setPosition(event.latLng);
          infoWindow.open(map);
          isInfoWindowOpen = true;
        }
      });
    };
  
    // Add a map click listener to close the InfoWindow if clicked outside
    map.addListener('click', () => {
      if (isInfoWindowOpen) {
        infoWindow.close();
        isInfoWindowOpen = false;
      }
    });
  
    // Plot GPS Loss intervals
    if (isGPSLoss && this.eventVisibility.get('no-gps')) {
      this.gpsLossIntervals.forEach(interval => {
        const [startPoint, endPoint, duration] = interval;
        const gpsLossPath = [
          new google.maps.LatLng(startPoint.latitude, startPoint.longitude), 
          new google.maps.LatLng(endPoint.latitude, endPoint.longitude)
        ];
    
        // Calculate the distance using Google Maps computeDistanceBetween
        const distance = google.maps.geometry.spherical.computeDistanceBetween(
          new google.maps.LatLng(startPoint.latitude, startPoint.longitude),
          new google.maps.LatLng(endPoint.latitude, endPoint.longitude)
        );
    
        // Format distance: Show in km if > 1000m, otherwise in meters
        const formattedDistance = distance >= 1000 
          ? (distance / 1000).toFixed(2) + " km"  // Convert meters to km and format
          : Math.round(distance) + " m"; // Keep it in meters if below 1000m
    
        const gpsLossPolyline = new google.maps.Polyline({
          path: gpsLossPath,
          geodesic: true,
          strokeColor: '#354052',
          strokeOpacity: 1.0,
          strokeWeight: 6,
          zIndex: 99,
        });
    
        this.mapControlService.gpsLossPolylineList.push(gpsLossPolyline);
        gpsLossPolyline.setMap(map);
    
        // Updated tooltip content with dynamic distance formatting
        const gpsLossContent = `
          <div>
            <h3>GPS Loss</h3>
            <p>Duration: ${DateUtils.formatTime(startPoint.time, "hh:mm")} - ${DateUtils.formatTime(endPoint.time, "hh:mm")}</p>
            <p>Length: ${duration} seconds</p>
          </div>
        `;
    
        openTooltip(gpsLossPolyline, gpsLossContent);
      });
    }
    
    
  
    // Plot Device Off intervals
    if (isDeviceOff && this.eventVisibility.get('device-off')) {
      this.deviceOffIntervals.forEach(interval => {
        const [startPoint, endPoint, duration] = interval;
        const deviceOffPath = [
          new google.maps.LatLng(startPoint.latitude, startPoint.longitude), 
          new google.maps.LatLng(endPoint.latitude, endPoint.longitude)
        ];
  
        const deviceOffPolyline = new google.maps.Polyline({
          path: deviceOffPath,
          geodesic: true,
          strokeColor: '#A0A0A0',
          strokeOpacity: 1.0,
          strokeWeight: 6,
          zIndex: 101,
        });
  
        this.mapControlService.deviceOffPolylineList.push(deviceOffPolyline);
        deviceOffPolyline.setMap(map);
  
        const deviceOffContent = `
          <div>
            <h3>Device Off</h3>
            <p>Duration: ${DateUtils.formatTime(startPoint.time, 'hh:mm')} - ${DateUtils.formatTime(endPoint.time, 'hh:mm')}</p>
            <p>Length: ${duration} seconds</p>
          </div>
        `;
        openTooltip(deviceOffPolyline, deviceOffContent);
      });
    }

  }
  
  async animatedMove(
    marker: any,
    current: { lat: any; lng: any },
    moveto: { lat: number; lng: number },
    bearing: any
  ) {
    if (!marker || !isValidCoordinate(current.lat, current.lng) || !isValidCoordinate(moveto.lat, moveto.lng)) return;
    var imgIcon = marker.getIcon();
    if(imgIcon) {
    imgIcon.url = `${this.replayImgSrc}assets/icons/cab-on-map.svg`
      imgIcon.rotation = bearing;
      marker.setIcon(imgIcon);
    }
    var nxlat = moveto.lat;
    var nxlng = moveto.lng;
    var deltalat = (moveto.lat - current.lat) / 100;
    var deltalng = (moveto.lng - current.lng) / 100;
    for (var i = 0; i < 100; i++) {
      (function (ind) {
        setTimeout(function () {
          var newLat = marker.position?.lat();
          var newLng = marker.position?.lng();
          newLat += deltalat;
          newLng += deltalng;
          if(newLat && newLng) {  
          marker.setPosition({ lat: newLat, lng: newLng });
          }
        }, 1 * ind);
      })(i);
    }
    marker.setValues({ lat: nxlat, lng: nxlng });
    let elemSel = document.querySelector(
      'img[src*="cab-on-map.svg"]'
    ) as HTMLElement;
    if (elemSel && bearing != null && bearing != 0) {
      elemSel.style.transform = `rotate(${bearing}deg)`;
    }
  }
  giveVehiclePause() {
    clearInterval(this.mapControlService.tripInterval);
    const pauseTimeout = setTimeout(() => {
      this.startTrip();
    }, 1000);
    this.mapControlService.timeoutSet.push(pauseTimeout);
  }
  selectedValue(value) {
    switch (value) {
      case 'Fixed Device':
        this.commonService.driverFixedDevice = true;
        this.reStart.emit()
        break;
      case 'Driver App':
        this.commonService.driverFixedDevice = false;
        this.reStart.emit()
        break;
      default:
        break;
    }
  }
  mapInitializer() {
    this.map = new google.maps.Map(
      document.getElementById('map') as HTMLElement,
      this.mapOptions
    );

    this.mapControlService.map = this.map;


  }
  ngOnDestroy() {
    this.activeInfoWindows.forEach(infoWindow => infoWindow.close());
    this.activeInfoWindows.clear();
    this.clearEventLoops();
  }
}
